import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { toast, Toaster } from "sonner";
import "./Admindashboard.css";

function AdminDashboard() {
    const navigate = useNavigate();
    const [userName, setUserName] = useState("");
    const [userRole, setUserRole] = useState("");
    
    const [users, setUsers] = useState([]);
    const [products, setProducts] = useState([]);
    const [categories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    
    const [showProductModal, setShowProductModal] = useState(false);
    const [showCategoryModal, setShowCategoryModal] = useState(false);
    const [showSubCategoryModal, setShowSubCategoryModal] = useState(false);
    const [showUserModal, setShowUserModal] = useState(false);
    const [editingProduct, setEditingProduct] = useState(null);
    const [editingCategory, setEditingCategory] = useState(null);
    const [editingSubCategory, setEditingSubCategory] = useState(null);
    const [editingUser, setEditingUser] = useState(null);

    const [productForm, setProductForm] = useState({
        name: "",
        price: 0,
        barcode: "",
        description: "",
        adresse_Image_Product: "",
        family: "",
        subFamily: "",
        category: "",
        sub_Category: "",
        actif: true,
        productType: 2,
        technicalSpecifications: ""
    });

    const [categoryForm, setCategoryForm] = useState({
        name: "",
        isActive: true
    });

    const [subCategoryForm, setSubCategoryForm] = useState({
        name: "",
        categoryId: "",
        isActive: true
    });

    const [userForm, setUserForm] = useState({
        firstName: "",
        lastName: "",
        email: "",
        mobile: "",
        mp: "",
        isEnabled: true
    });

    const API_URL = "http://localhost:5233/api";

    const getAuthHeaders = useCallback(() => {
        const token = localStorage.getItem("token");
        return {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
        };
    }, []);

    const handleUnauthorized = useCallback(() => {
        toast.error("Session expirée. Veuillez vous reconnecter.");
        localStorage.clear();
        navigate("/login");
    }, [navigate]);

    const fetchUsers = useCallback(async () => {
        try {
            console.log("📡 Fetching users...");
            const response = await fetch(`${API_URL}/User/GetUsers`, {
                method: "GET",
                headers: getAuthHeaders()
            });

            console.log("📥 Users response status:", response.status);

            if (response.status === 401) {
                handleUnauthorized();
                return;
            }

            if (response.ok) {
                const data = await response.json();
                setUsers(data);
                console.log(`✅ ${data.length} utilisateurs chargés`);
            } else {
                const errorText = await response.text();
                console.error("❌ Erreur HTTP users:", response.status, errorText);
                toast.error(`Erreur lors du chargement des utilisateurs: ${response.status}`);
            }
        } catch (error) {
            console.error("❌ Erreur fetch users:", error);
            toast.error("Erreur réseau lors du chargement des utilisateurs");
        }
    }, [getAuthHeaders, handleUnauthorized]);

    const fetchProducts = useCallback(async () => {
        try {
            console.log("📡 Fetching products...");
            const response = await fetch(`${API_URL}/Product/get-list-products`, {
                method: "GET",
                headers: getAuthHeaders()
            });

            console.log("📥 Products response status:", response.status);

            if (response.status === 401) {
                handleUnauthorized();
                return;
            }

            if (response.ok) {
                const data = await response.json();
                setProducts(data);
                console.log(`✅ ${data.length} produits chargés`);
            } else {
                const errorText = await response.text();
                console.error("❌ Erreur HTTP products:", response.status, errorText);
                toast.error(`Erreur lors du chargement des produits: ${response.status}`);
            }
        } catch (error) {
            console.error("❌ Erreur fetch products:", error);
            toast.error("Erreur réseau lors du chargement des produits");
        }
    }, [getAuthHeaders, handleUnauthorized]);

    const fetchCategories = useCallback(async () => {
        try {
            console.log("📡 Fetching categories...");
            const response = await fetch(`${API_URL}/Category/get-all`, {
                method: "GET",
                headers: getAuthHeaders()
            });

            console.log("📥 Categories response status:", response.status);

            if (response.status === 401) {
                handleUnauthorized();
                return;
            }

            if (response.ok) {
                const data = await response.json();
                setCategories(data);
                console.log(`✅ ${data.length} catégories chargées`);
            } else {
                const errorText = await response.text();
                console.error("❌ Erreur HTTP categories:", response.status, errorText);
                toast.error(`Erreur lors du chargement des catégories: ${response.status}`);
            }
        } catch (error) {
            console.error("❌ Erreur fetch categories:", error);
            toast.error("Erreur réseau lors du chargement des catégories");
        }
    }, [getAuthHeaders, handleUnauthorized]);

    const fetchSubCategories = useCallback(async () => {
        try {
            console.log("📡 Fetching subcategories...");
            const response = await fetch(`${API_URL}/SubCategory/get-all`, {
                method: "GET",
                headers: getAuthHeaders()
            });

            console.log("📥 SubCategories response status:", response.status);

            if (response.status === 401) {
                handleUnauthorized();
                return;
            }

            if (response.ok) {
                const data = await response.json();
                setSubCategories(data);
                console.log(`✅ ${data.length} sous-catégories chargées`);
            } else {
                const errorText = await response.text();
                console.error("❌ Erreur HTTP subcategories:", response.status, errorText);
                toast.error(`Erreur lors du chargement des sous-catégories: ${response.status}`);
            }
        } catch (error) {
            console.error("❌ Erreur fetch subcategories:", error);
            toast.error("Erreur réseau lors du chargement des sous-catégories");
        }
    }, [getAuthHeaders, handleUnauthorized]);

    const fetchAllData = useCallback(async () => {
        setLoading(true);
        try {
            await Promise.all([
                fetchUsers(),
                fetchProducts(),
                fetchCategories(),
                fetchSubCategories()
            ]);
            toast.success("Données chargées avec succès");
        } catch (error) {
            console.error("❌ Erreur lors du chargement:", error);
            toast.error("Erreur lors du chargement des données");
        } finally {
            setLoading(false);
        }
    }, [fetchUsers, fetchProducts, fetchCategories, fetchSubCategories]);

    useEffect(() => {
        const token = localStorage.getItem("token");
        const nom = localStorage.getItem("nom");
        const role = localStorage.getItem("userRole");

        console.log("🔍 Vérification admin:", { 
            hasToken: !!token, 
            nom, 
            role,
            tokenPreview: token ? `${token.substring(0, 20)}...` : "none"
        });

        if (!token) {
            console.log("❌ Pas de token, redirection vers login");
            toast.error("Veuillez vous connecter");
            navigate("/login");
            return;
        }

        if (role?.toLowerCase() !== "admin") {
            console.log("❌ Pas admin, redirection vers home");
            toast.error("Accès refusé. Droits administrateur requis.");
            navigate("/");
            return;
        }

        console.log("✅ Admin authentifié");
        setUserName(nom || "Administrateur");
        setUserRole(role || "Admin");

        fetchAllData();
    }, [navigate, fetchAllData]);


    const handleProductSubmit = async (e) => {
        e.preventDefault();

        try {
            const url = editingProduct
                ? `${API_URL}/Product/update-product/${editingProduct.id}`
                : `${API_URL}/Product/add-product`;

            const method = editingProduct ? "PUT" : "POST";

            console.log("📤 Envoi produit:", { url, method, data: productForm });

            const response = await fetch(url, {
                method,
                headers: getAuthHeaders(),
                body: JSON.stringify({
                    Name: productForm.name,
                    Price: productForm.price,
                    Barcode: productForm.barcode,
                    Description: productForm.description,
                    Adresse_Image_Product: productForm.adresse_Image_Product,
                    Family: productForm.family,
                    SubFamily: productForm.subFamily,
                    Category: productForm.category,
                    Sub_Category: productForm.sub_Category,
                    Actif: productForm.actif,
                    ProductType: productForm.productType,
                    TechnicalSpecifications: productForm.technicalSpecifications
                })
            });

            if (response.status === 401) {
                handleUnauthorized();
                return;
            }

            if (response.ok) {
                toast.success(editingProduct ? "Produit mis à jour avec succès" : "Produit créé avec succès");
                setShowProductModal(false);
                resetProductForm();
                await fetchProducts();
            } else {
                const errorText = await response.text();
                console.error("❌ Erreur serveur:", response.status, errorText);
                toast.error(`Erreur: ${errorText || "Erreur serveur"}`);
            }
        } catch (error) {
            console.error("❌ Erreur réseau:", error);
            toast.error("Erreur de connexion au serveur");
        }
    };

    const handleDeleteProduct = async (productId) => {
        if (!window.confirm("Voulez-vous vraiment supprimer ce produit ?")) return;

        try {
            const response = await fetch(`${API_URL}/Product/delete-product/${productId}`, {
                method: "DELETE",
                headers: getAuthHeaders()
            });

            if (response.status === 401) {
                handleUnauthorized();
                return;
            }

            if (response.ok) {
                toast.success("Produit supprimé avec succès");
                await fetchProducts();
            } else {
                const errorText = await response.text();
                toast.error(`Erreur: ${errorText}`);
            }
        } catch (error) {
            console.error("❌ Erreur:", error);
            toast.error("Erreur de connexion au serveur");
        }
    };

    const handleEditProduct = (product) => {
        setEditingProduct(product);
        setProductForm({
            name: product.name || "",
            price: product.price || 0,
            barcode: product.barcode || "",
            description: product.description || "",
            adresse_Image_Product: product.adresse_Image_Product || "",
            family: product.family || "",
            subFamily: product.subFamily || "",
            category: product.category || "",
            sub_Category: product.sub_Category || "",
            actif: product.actif ?? true,
            productType: product.productType || 2,
            technicalSpecifications: product.technicalSpecifications || ""
        });
        setShowProductModal(true);
    };

    const resetProductForm = () => {
        setEditingProduct(null);
        setProductForm({
            name: "",
            price: 0,
            barcode: "",
            description: "",
            adresse_Image_Product: "",
            family: "",
            subFamily: "",
            category: "",
            sub_Category: "",
            actif: true,
            productType: 2,
            technicalSpecifications: ""
        });
    };

    const handleCategorySubmit = async (e) => {
        e.preventDefault();

        try {
            const url = editingCategory
                ? `${API_URL}/Category/update/${editingCategory.id}`
                : `${API_URL}/Category/create`;

            const method = editingCategory ? "PUT" : "POST";

            console.log("📤 Envoi catégorie:", { url, method, data: categoryForm });

            const response = await fetch(url, {
                method,
                headers: getAuthHeaders(),
                body: JSON.stringify(categoryForm)
            });

            if (response.status === 401) {
                handleUnauthorized();
                return;
            }

            if (response.ok) {
                toast.success(editingCategory ? "Catégorie mise à jour avec succès" : "Catégorie créée avec succès");
                setShowCategoryModal(false);
                resetCategoryForm();
                await fetchCategories();
            } else {
                const errorText = await response.text();
                console.error("❌ Erreur serveur:", response.status, errorText);
                toast.error(`Erreur: ${errorText || "Erreur serveur"}`);
            }
        } catch (error) {
            console.error("❌ Erreur réseau:", error);
            toast.error("Erreur de connexion au serveur");
        }
    };

    const handleDeleteCategory = async (categoryId) => {
        if (!window.confirm("Voulez-vous vraiment supprimer cette catégorie ?")) return;

        try {
            const response = await fetch(`${API_URL}/Category/delete/${categoryId}`, {
                method: "DELETE",
                headers: getAuthHeaders()
            });

            if (response.status === 401) {
                handleUnauthorized();
                return;
            }

            if (response.ok) {
                toast.success("Catégorie supprimée avec succès");
                await fetchCategories();
            } else {
                const errorText = await response.text();
                toast.error(`Erreur: ${errorText}`);
            }
        } catch (error) {
            console.error("❌ Erreur:", error);
            toast.error("Erreur de connexion au serveur");
        }
    };

    const handleEditCategory = (category) => {
        setEditingCategory(category);
        setCategoryForm({
            name: category.name || "",
            isActive: category.isActive ?? true
        });
        setShowCategoryModal(true);
    };

    const resetCategoryForm = () => {
        setEditingCategory(null);
        setCategoryForm({ name: "", isActive: true });
    };


    const handleSubCategorySubmit = async (e) => {
        e.preventDefault();

        try {
            const url = editingSubCategory
                ? `${API_URL}/SubCategory/update/${editingSubCategory.id}`
                : `${API_URL}/SubCategory/create`;

            const method = editingSubCategory ? "PUT" : "POST";

            console.log("📤 Envoi sous-catégorie:", { url, method, data: subCategoryForm });

            const response = await fetch(url, {
                method,
                headers: getAuthHeaders(),
                body: JSON.stringify(subCategoryForm)
            });

            if (response.status === 401) {
                handleUnauthorized();
                return;
            }

            if (response.ok) {
                toast.success(editingSubCategory ? "Sous-catégorie mise à jour avec succès" : "Sous-catégorie créée avec succès");
                setShowSubCategoryModal(false);
                resetSubCategoryForm();
                await fetchSubCategories();
            } else {
                const errorText = await response.text();
                console.error("❌ Erreur serveur:", response.status, errorText);
                toast.error(`Erreur: ${errorText || "Erreur serveur"}`);
            }
        } catch (error) {
            console.error("❌ Erreur réseau:", error);
            toast.error("Erreur de connexion au serveur");
        }
    };

    const handleDeleteSubCategory = async (subCategoryId) => {
        if (!window.confirm("Voulez-vous vraiment supprimer cette sous-catégorie ?")) return;

        try {
            const response = await fetch(`${API_URL}/SubCategory/delete/${subCategoryId}`, {
                method: "DELETE",
                headers: getAuthHeaders()
            });

            if (response.status === 401) {
                handleUnauthorized();
                return;
            }

            if (response.ok) {
                toast.success("Sous-catégorie supprimée avec succès");
                await fetchSubCategories();
            } else {
                const errorText = await response.text();
                toast.error(`Erreur: ${errorText}`);
            }
        } catch (error) {
            console.error("❌ Erreur:", error);
            toast.error("Erreur de connexion au serveur");
        }
    };

    const handleEditSubCategory = (subCategory) => {
        setEditingSubCategory(subCategory);
        setSubCategoryForm({
            name: subCategory.name || "",
            categoryId: subCategory.categoryId || "",
            isActive: subCategory.isActive ?? true
        });
        setShowSubCategoryModal(true);
    };

    const resetSubCategoryForm = () => {
        setEditingSubCategory(null);
        setSubCategoryForm({ name: "", categoryId: "", isActive: true });
    };


    const handleUserSubmit = async (e) => {
        e.preventDefault();

        try {
            const url = editingUser
                ? `${API_URL}/User/updateUser/${editingUser.id}`
                : `${API_URL}/User/addUser`;

            const method = editingUser ? "PUT" : "POST";

            console.log("📤 Envoi utilisateur:", { url, method, data: userForm });

            const response = await fetch(url, {
                method,
                headers: getAuthHeaders(),
                body: JSON.stringify(userForm)
            });

            if (response.status === 401) {
                handleUnauthorized();
                return;
            }

            if (response.ok) {
                toast.success(editingUser ? "Utilisateur mis à jour avec succès" : "Utilisateur créé avec succès");
                setShowUserModal(false);
                resetUserForm();
                await fetchUsers();
            } else {
                const errorText = await response.text();
                console.error("❌ Erreur serveur:", response.status, errorText);
                toast.error(`Erreur: ${errorText || "Erreur serveur"}`);
            }
        } catch (error) {
            console.error("❌ Erreur réseau:", error);
            toast.error("Erreur de connexion au serveur");
        }
    };

    const handleDeleteUser = async (userId) => {
        if (!window.confirm("Voulez-vous vraiment supprimer cet utilisateur ?")) return;

        try {
            const response = await fetch(`${API_URL}/User/deleteUser/${userId}`, {
                method: "DELETE",
                headers: getAuthHeaders()
            });

            if (response.status === 401) {
                handleUnauthorized();
                return;
            }

            if (response.ok) {
                toast.success("Utilisateur supprimé avec succès");
                await fetchUsers();
            } else {
                const errorText = await response.text();
                toast.error(`Erreur: ${errorText}`);
            }
        } catch (error) {
            console.error("❌ Erreur:", error);
            toast.error("Erreur de connexion au serveur");
        }
    };

    const handleEditUser = (user) => {
        setEditingUser(user);
        setUserForm({
            firstName: user.firstName || "",
            lastName: user.lastName || "",
            email: user.email || "",
            mobile: user.mobile || "",
            mp: "",
            isEnabled: user.isEnabled ?? true
        });
        setShowUserModal(true);
    };

    const resetUserForm = () => {
        setEditingUser(null);
        setUserForm({
            firstName: "",
            lastName: "",
            email: "",
            mobile: "",
            mp: "",
            isEnabled: true
        });
    };


    const handleLogout = () => {
        localStorage.clear();
        toast.info("Déconnexion réussie");
        navigate("/login");
    };


    if (loading) {
        return (
            <>
                <Toaster position="top-right" richColors />
                <div className="loading-container">
                    <div className="spinner"></div>
                    <p>Chargement des données...</p>
                </div>
            </>
        );
    }

 
    return (
        <>
            <Toaster position="top-right" richColors />
            <div className="admin-dashboard">
                <header className="dashboard-header">
                    <div className="header-content">
                        <h1>🎛️ Tableau de bord Admin</h1>
                        <div className="user-info">
                            <span>👤 {userName}</span>
                            <span className="role-badge">{userRole}</span>
                            <button onClick={handleLogout} className="logout-btn">
                                <i className="fas fa-sign-out-alt"></i>
                                Déconnexion
                            </button>
                        </div>
                    </div>
                </header>

                <div className="dashboard-content">
                
                    <div className="welcome-section">
                        <h2>Bienvenue, {userName} !</h2>
                        <p>Vous êtes connecté en tant qu'administrateur.</p>
                    </div>

                    <div className="stats-grid">
                        <div className="stat-card">
                            <div className="stat-icon">👥</div>
                            <div className="stat-info">
                                <h3>Utilisateurs</h3>
                                <p className="stat-value">{users.length}</p>
                            </div>
                        </div>

                        <div className="stat-card">
                            <div className="stat-icon">📦</div>
                            <div className="stat-info">
                                <h3>Produits</h3>
                                <p className="stat-value">{products.length}</p>
                            </div>
                        </div>

                        <div className="stat-card">
                            <div className="stat-icon">🏷️</div>
                            <div className="stat-info">
                                <h3>Catégories</h3>
                                <p className="stat-value">{categories.length}</p>
                            </div>
                        </div>

                        <div className="stat-card">
                            <div className="stat-icon">📑</div>
                            <div className="stat-info">
                                <h3>Sous-catégories</h3>
                                <p className="stat-value">{subCategories.length}</p>
                            </div>
                        </div>
                    </div>

                    <div className="quick-actions">
                        <h3>Actions rapides</h3>
                        <div className="actions-grid">
                            <button onClick={() => { resetProductForm(); setShowProductModal(true); }} className="action-btn">
                                <i className="fas fa-plus"></i>
                                Ajouter un produit
                            </button>
                            <button onClick={() => { resetCategoryForm(); setShowCategoryModal(true); }} className="action-btn">
                                <i className="fas fa-tag"></i>
                                Ajouter une catégorie
                            </button>
                            <button onClick={() => { resetSubCategoryForm(); setShowSubCategoryModal(true); }} className="action-btn">
                                <i className="fas fa-tags"></i>
                                Ajouter une sous-catégorie
                            </button>
                            <button onClick={() => { resetUserForm(); setShowUserModal(true); }} className="action-btn">
                                <i className="fas fa-user-plus"></i>
                                Ajouter un utilisateur
                            </button>
                        </div>
                    </div>

                    
                    <div className="data-section">
                        <div className="section-header">
                            <h3>📦 Liste des produits</h3>
                            <button onClick={() => { resetProductForm(); setShowProductModal(true); }} className="add-btn">
                                + Nouveau produit
                            </button>
                        </div>
                        <div className="table-container">
                            <table className="data-table">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Nom</th>
                                        <th>Prix</th>
                                        <th>Code-barres</th>
                                        <th>Catégorie</th>
                                        <th>Sous-catégorie</th>
                                        <th>Type</th>
                                        <th>Actif</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {products.length === 0 ? (
                                        <tr>
                                            <td colSpan="9" style={{ textAlign: 'center' }}>Aucun produit</td>
                                        </tr>
                                    ) : (
                                        products.map(product => (
                                            <tr key={product.id}>
                                                <td>{product.id}</td>
                                                <td>{product.name}</td>
                                                <td>{product.price} DT</td>
                                                <td>{product.barcode || "N/A"}</td>
                                                <td>{product.category || "N/A"}</td>
                                                <td>{product.sub_Category || "N/A"}</td>
                                                <td>
                                                    <span className={`badge ${product.productType === 1 ? 'badge-internal' : 'badge-sale'}`}>
                                                        {product.productType === 1 ? "Interne" : "Vente"}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className={`status-badge ${product.actif ? 'active' : 'inactive'}`}>
                                                        {product.actif ? "✓" : "✗"}
                                                    </span>
                                                </td>
                                                <td className="action-buttons">
                                                    <button onClick={() => handleEditProduct(product)} className="btn-edit" title="Modifier">
                                                        ✏️
                                                    </button>
                                                    <button onClick={() => handleDeleteProduct(product.id)} className="btn-delete" title="Supprimer">
                                                        🗑️
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="data-section">
                        <div className="section-header">
                            <h3>🏷️ Liste des catégories</h3>
                            <button onClick={() => { resetCategoryForm(); setShowCategoryModal(true); }} className="add-btn">
                                + Nouvelle catégorie
                            </button>
                        </div>
                        <div className="table-container">
                            <table className="data-table">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Nom</th>
                                        <th>Actif</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {categories.length === 0 ? (
                                        <tr>
                                            <td colSpan="4" style={{ textAlign: 'center' }}>Aucune catégorie</td>
                                        </tr>
                                    ) : (
                                        categories.map(category => (
                                            <tr key={category.id}>
                                                <td>{category.id}</td>
                                                <td>{category.name}</td>
                                                <td>
                                                    <span className={`status-badge ${category.isActive ? 'active' : 'inactive'}`}>
                                                        {category.isActive ? "✓" : "✗"}
                                                    </span>
                                                </td>
                                                <td className="action-buttons">
                                                    <button onClick={() => handleEditCategory(category)} className="btn-edit" title="Modifier">
                                                        ✏️
                                                    </button>
                                                    <button onClick={() => handleDeleteCategory(category.id)} className="btn-delete" title="Supprimer">
                                                        🗑️
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="data-section">
                        <div className="section-header">
                            <h3>📑 Liste des sous-catégories</h3>
                            <button onClick={() => { resetSubCategoryForm(); setShowSubCategoryModal(true); }} className="add-btn">
                                + Nouvelle sous-catégorie
                            </button>
                        </div>
                        <div className="table-container">
                            <table className="data-table">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Nom</th>
                                        <th>Catégorie</th>
                                        <th>Actif</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {subCategories.length === 0 ? (
                                        <tr>
                                            <td colSpan="5" style={{ textAlign: 'center' }}>Aucune sous-catégorie</td>
                                        </tr>
                                    ) : (
                                        subCategories.map(subCategory => (
                                            <tr key={subCategory.id}>
                                                <td>{subCategory.id}</td>
                                                <td>{subCategory.name}</td>
                                                <td>
                                                    {categories.find(c => c.id === subCategory.categoryId)?.name || "N/A"}
                                                </td>
                                                <td>
                                                    <span className={`status-badge ${subCategory.isActive ? 'active' : 'inactive'}`}>
                                                        {subCategory.isActive ? "✓" : "✗"}
                                                    </span>
                                                </td>
                                                <td className="action-buttons">
                                                    <button onClick={() => handleEditSubCategory(subCategory)} className="btn-edit" title="Modifier">
                                                        ✏️
                                                    </button>
                                                    <button onClick={() => handleDeleteSubCategory(subCategory.id)} className="btn-delete" title="Supprimer">
                                                        🗑️
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* TABLE UTILISATEURS */}
                    <div className="data-section">
                        <div className="section-header">
                            <h3>👥 Liste des utilisateurs</h3>
                            <button onClick={() => { resetUserForm(); setShowUserModal(true); }} className="add-btn">
                                + Nouvel utilisateur
                            </button>
                        </div>
                        <div className="table-container">
                            <table className="data-table">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Nom</th>
                                        <th>Prénom</th>
                                        <th>Email</th>
                                        <th>Mobile</th>
                                        <th>Rôle</th>
                                        <th>Actif</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {users.length === 0 ? (
                                        <tr>
                                            <td colSpan="8" style={{ textAlign: 'center' }}>Aucun utilisateur</td>
                                        </tr>
                                    ) : (
                                        users.map(user => (
                                            <tr key={user.id}>
                                                <td>{user.id}</td>
                                                <td>{user.lastName}</td>
                                                <td>{user.firstName}</td>
                                                <td>{user.email}</td>
                                                <td>{user.mobile}</td>
                                                <td>{user.role?.name || "N/A"}</td>
                                                <td>
                                                    <span className={`status-badge ${user.isEnabled ? 'active' : 'inactive'}`}>
                                                        {user.isEnabled ? "✓" : "✗"}
                                                    </span>
                                                </td>
                                                <td className="action-buttons">
                                                    <button onClick={() => handleEditUser(user)} className="btn-edit" title="Modifier">
                                                        ✏️
                                                    </button>
                                                    <button onClick={() => handleDeleteUser(user.id)} className="btn-delete" title="Supprimer">
                                                        🗑️
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                {showProductModal && (
                    <div className="modal-overlay" onClick={() => setShowProductModal(false)}>
                        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                            <div className="modal-header">
                                <h2>{editingProduct ? "✏️ Modifier le produit" : "➕ Nouveau produit"}</h2>
                                <button className="close-btn" onClick={() => setShowProductModal(false)}>✖</button>
                            </div>
                            <form onSubmit={handleProductSubmit} className="modal-form">
                                <div className="form-row">
                                    <div className="form-group">
                                        <label>Nom *</label>
                                        <input
                                            type="text"
                                            value={productForm.name}
                                            onChange={(e) => setProductForm({ ...productForm, name: e.target.value })}
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Prix *</label>
                                        <input
                                            type="number"
                                            step="0.01"
                                            value={productForm.price}
                                            onChange={(e) => setProductForm({ ...productForm, price: parseFloat(e.target.value) || 0 })}
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group">
                                        <label>Code-barres</label>
                                        <input
                                            type="text"
                                            value={productForm.barcode}
                                            onChange={(e) => setProductForm({ ...productForm, barcode: e.target.value })}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Type de produit</label>
                                        <select
                                            value={productForm.productType}
                                            onChange={(e) => setProductForm({ ...productForm, productType: parseInt(e.target.value) })}
                                        >
                                            <option value={1}>Interne</option>
                                            <option value={2}>Vente</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label>Description</label>
                                    <textarea
                                        value={productForm.description}
                                        onChange={(e) => setProductForm({ ...productForm, description: e.target.value })}
                                        rows="3"
                                    />
                                </div>

                                <div className="form-row">
                                    <div className="form-group">
                                        <label>Famille</label>
                                        <input
                                            type="text"
                                            value={productForm.family}
                                            onChange={(e) => setProductForm({ ...productForm, family: e.target.value })}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Sous-famille</label>
                                        <input
                                            type="text"
                                            value={productForm.subFamily}
                                            onChange={(e) => setProductForm({ ...productForm, subFamily: e.target.value })}
                                        />
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group">
                                        <label>Catégorie *</label>
                                        <select
                                            value={productForm.category}
                                            onChange={(e) => {
                                                const selectedCategoryName = e.target.value;
                                                setProductForm({ 
                                                    ...productForm, 
                                                    category: selectedCategoryName,
                                                    sub_Category: ""
                                                });
                                            }}
                                            required
                                        >
                                            <option value="">-- Sélectionner une catégorie --</option>
                                            {categories.filter(c => c.isActive).map(cat => (
                                                <option key={cat.id} value={cat.name}>{cat.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label>Sous-catégorie</label>
                                        <select
                                            value={productForm.sub_Category}
                                            onChange={(e) => setProductForm({ ...productForm, sub_Category: e.target.value })}
                                            disabled={!productForm.category}
                                        >
                                            <option value="">-- Sélectionner une sous-catégorie --</option>
                                            {subCategories
                                                .filter(sc => {
                                                    const selectedCategory = categories.find(c => c.name === productForm.category);
                                                    return sc.isActive && selectedCategory && sc.categoryId === selectedCategory.id;
                                                })
                                                .map(subCat => (
                                                    <option key={subCat.id} value={subCat.name}>{subCat.name}</option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label>URL de l'image</label>
                                    <input
                                        type="text"
                                        value={productForm.adresse_Image_Product}
                                        onChange={(e) => setProductForm({ ...productForm, adresse_Image_Product: e.target.value })}
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Spécifications techniques</label>
                                    <textarea
                                        value={productForm.technicalSpecifications}
                                        onChange={(e) => setProductForm({ ...productForm, technicalSpecifications: e.target.value })}
                                        rows="4"
                                    />
                                </div>

                                <div className="form-group checkbox-group">
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={productForm.actif}
                                            onChange={(e) => setProductForm({ ...productForm, actif: e.target.checked })}
                                        />
                                        Produit actif
                                    </label>
                                </div>

                                <div className="modal-actions">
                                    <button type="button" onClick={() => setShowProductModal(false)} className="btn-cancel">
                                        Annuler
                                    </button>
                                    <button type="submit" className="btn-submit">
                                        {editingProduct ? "Mettre à jour" : "Créer"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}

                {showCategoryModal && (
                    <div className="modal-overlay" onClick={() => setShowCategoryModal(false)}>
                        <div className="modal-content modal-small" onClick={(e) => e.stopPropagation()}>
                            <div className="modal-header">
                                <h2>{editingCategory ? "✏️ Modifier la catégorie" : "➕ Nouvelle catégorie"}</h2>
                                <button className="close-btn" onClick={() => setShowCategoryModal(false)}>✖</button>
                            </div>
                            <form onSubmit={handleCategorySubmit} className="modal-form">
                                <div className="form-group">
                                    <label>Nom *</label>
                                    <input
                                        type="text"
                                        value={categoryForm.name}
                                        onChange={(e) => setCategoryForm({ ...categoryForm, name: e.target.value })}
                                        required
                                    />
                                </div>

                                <div className="form-group checkbox-group">
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={categoryForm.isActive}
                                            onChange={(e) => setCategoryForm({ ...categoryForm, isActive: e.target.checked })}
                                        />
                                        Catégorie active
                                    </label>
                                </div>

                                <div className="modal-actions">
                                    <button type="button" onClick={() => setShowCategoryModal(false)} className="btn-cancel">
                                        Annuler
                                    </button>
                                    <button type="submit" className="btn-submit">
                                        {editingCategory ? "Mettre à jour" : "Créer"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}

                {showSubCategoryModal && (
                    <div className="modal-overlay" onClick={() => setShowSubCategoryModal(false)}>
                        <div className="modal-content modal-small" onClick={(e) => e.stopPropagation()}>
                            <div className="modal-header">
                                <h2>{editingSubCategory ? "✏️ Modifier la sous-catégorie" : "➕ Nouvelle sous-catégorie"}</h2>
                                <button className="close-btn" onClick={() => setShowSubCategoryModal(false)}>✖</button>
                            </div>
                            <form onSubmit={handleSubCategorySubmit} className="modal-form">
                                <div className="form-group">
                                    <label>Nom *</label>
                                    <input
                                        type="text"
                                        value={subCategoryForm.name}
                                        onChange={(e) => setSubCategoryForm({ ...subCategoryForm, name: e.target.value })}
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Catégorie *</label>
                                    <select
                                        value={subCategoryForm.categoryId}
                                        onChange={(e) => setSubCategoryForm({ ...subCategoryForm, categoryId: parseInt(e.target.value) || "" })}
                                        required
                                    >
                                        <option value="">-- Sélectionner --</option>
                                        {categories.map(cat => (
                                            <option key={cat.id} value={cat.id}>{cat.name}</option>
                                        ))}
                                    </select>
                                </div>

                                <div className="form-group checkbox-group">
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={subCategoryForm.isActive}
                                            onChange={(e) => setSubCategoryForm({ ...subCategoryForm, isActive: e.target.checked })}
                                        />
                                        Sous-catégorie active
                                    </label>
                                </div>

                                <div className="modal-actions">
                                    <button type="button" onClick={() => setShowSubCategoryModal(false)} className="btn-cancel">
                                        Annuler
                                    </button>
                                    <button type="submit" className="btn-submit">
                                        {editingSubCategory ? "Mettre à jour" : "Créer"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}

                
                {showUserModal && (
                    <div className="modal-overlay" onClick={() => setShowUserModal(false)}>
                        <div className="modal-content modal-small" onClick={(e) => e.stopPropagation()}>
                            <div className="modal-header">
                                <h2>{editingUser ? "✏️ Modifier l'utilisateur" : "➕ Nouvel utilisateur"}</h2>
                                <button className="close-btn" onClick={() => setShowUserModal(false)}>✖</button>
                            </div>
                            <form onSubmit={handleUserSubmit} className="modal-form">
                                <div className="form-row">
                                    <div className="form-group">
                                        <label>Prénom *</label>
                                        <input
                                            type="text"
                                            value={userForm.firstName}
                                            onChange={(e) => setUserForm({ ...userForm, firstName: e.target.value })}
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Nom *</label>
                                        <input
                                            type="text"
                                            value={userForm.lastName}
                                            onChange={(e) => setUserForm({ ...userForm, lastName: e.target.value })}
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label>Email *</label>
                                    <input
                                        type="email"
                                        value={userForm.email}
                                        onChange={(e) => setUserForm({ ...userForm, email: e.target.value })}
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Mobile *</label>
                                    <input
                                        type="tel"
                                        value={userForm.mobile}
                                        onChange={(e) => setUserForm({ ...userForm, mobile: e.target.value })}
                                        required
                                    />
                                </div>

                                {!editingUser && (
                                    <div className="form-group">
                                        <label>Mot de passe *</label>
                                        <input
                                            type="password"
                                            value={userForm.mp}
                                            onChange={(e) => setUserForm({ ...userForm, mp: e.target.value })}
                                            required={!editingUser}
                                            placeholder={editingUser ? "Laisser vide pour ne pas changer" : ""}
                                        />
                                    </div>
                                )}

                                <div className="form-group checkbox-group">
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={userForm.isEnabled}
                                            onChange={(e) => setUserForm({ ...userForm, isEnabled: e.target.checked })}
                                        />
                                        Compte actif
                                    </label>
                                </div>

                                <div className="modal-actions">
                                    <button type="button" onClick={() => setShowUserModal(false)} className="btn-cancel">
                                        Annuler
                                    </button>
                                    <button type="submit" className="btn-submit">
                                        {editingUser ? "Mettre à jour" : "Créer"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}

export default AdminDashboard;